<section>
  <div class="border_container">
    <div class="row align-items-center">
      <div class="row mb-2 ">
        <div class="col-12">
          <p-tabs value="{{activeTabIndex}}" class="custom-tabs">
            <p-tablist class="custom-tablist" style="display: flex; align-items: center;">
              <p-tab (click)="handleTabChange(0)" value="0">Resumen</p-tab>
              <p-tab (click)="handleTabChange(1)" value="1" [disabled]="quotationContract.quotationId === 0"> Editar
                Solución</p-tab>
            </p-tablist>
            <p-tabpanels>
              <p-tabpanel value="0">
                <div class="container-style">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end mb-1">
                    <app-custom-button [title]="'Nueva Solución'" [label]="'Nueva Solución'"
                      (onClick)="createNewSolution()" [severity]="'success'" [width]="'8.5rem'" [icon]="'pi pi-plus'"
                      [disabled]="!quotationVersion.active || quotationContract.quotationId === 0"></app-custom-button>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-12 ">
                    <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
                      [showCheckbox]=" !this.disabledDetail " [checkBoxAction]="checkboxActions"
                      [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getQuotationDetailsByVersion()"
                      (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
                    </app-custom-table>
                  </div>
                </div>
              </p-tabpanel>
              <p-tabpanel value="1">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12 ">
                  <app-new-register-quotation-detail [quotationVersion]="quotationVersion"
                    [quotationContract]="quotationContract" [quotationDetailContract]="quotationDetailModel"
                    [permissionUpdatable]="permissionUpdatable" [updateFormDetail]="updateFormDetail"
                    (updateQuotationDetail)="getQuotationDetailsByVersion()"></app-new-register-quotation-detail>
                </div>
              </p-tabpanel>
            </p-tabpanels>
          </p-tabs>
        </div>
      </div>
    </div>
  </div>
</section>